/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupMemberRole = zod.object({
  name: zod.string(),
  roleUuid: zod.uuid(),
});

export type GroupMemberRole = zod.input<typeof GroupMemberRole>;
export type GroupMemberRoleOutput = zod.output<typeof GroupMemberRole>;
